import {
  errorLoading,
  loading,
  loaded,
  uploading,
  endUploading,
  responseHandler,
  tokenInterceptor,
  errorGetStatus,
} from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'
import { fetchAppsAction } from './AppWS'

let urlServer = Constants.UrlsConstants.urlServer

export const designWS = (state = {
  palettes: [], selectedPalette: [], colors: {}, fonts: [], hasUpdated: false, mapping: null
}, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.DESIGN.SET_COLOURLOVERS_PALETTES:
      return Object.assign({}, state, { palettes: action.datas })
    case Constants.ActionsConstants.DESIGN.SET_SELECTED_PALETTE:
      return Object.assign({}, state, { selectedPalette: action.datas })
    case Constants.ActionsConstants.DESIGN.SET_COLORS:
      return Object.assign({}, state, { colors: action.datas})
    case Constants.ActionsConstants.DESIGN.UPDATE_COLORS:
      return Object.assign({}, state, { colors: action.datas, hasUpdated: true })
    case Constants.ActionsConstants.DESIGN.SET_FONTS:
      return Object.assign({}, state, { fonts: action.datas })
    case Constants.ActionsConstants.DESIGN.SET_MAPPING:
      return Object.assign({}, state, { mapping: action.datas })
    default:
      return state
  }
}

export const setPalettes = (data) => {
  return {
    type: Constants.ActionsConstants.DESIGN.SET_COLOURLOVERS_PALETTES,
    datas: data,
  }
}

export const setSelectedPalette = (data) => {
  return {
    type: Constants.ActionsConstants.DESIGN.SET_SELECTED_PALETTE,
    datas: data,
  }
}

export const setColors = (data) => {
  return {
    type: Constants.ActionsConstants.DESIGN.SET_COLORS,
    datas: data
  }
}

export const updateColors = (data) => {
  return {
    type: Constants.ActionsConstants.DESIGN.UPDATE_COLORS,
    datas: data,
  }
}

export const setFonts = (data) => {
  return {
    type: Constants.ActionsConstants.DESIGN.SET_FONTS,
    datas: data,
  }
}
export const setMapping = (data) => {
  return {
    type: Constants.ActionsConstants.DESIGN.SET_MAPPING,
    datas: data,
  }
}
export function palettesAction(dispatch, appId, colors = null) {

  function fetchWS() {
    // build url
    let entryPoint = Constants.UrlsConstants.styleEntryPoint
    let method = Constants.MethodsWSConstants.STYLES.FETCH_STYLES
    let queryParams = appId + '/' + Constants.AppsConstants.STYLES.CATEGORIES.PALETTE

    fetch(urlServer + entryPoint + method + queryParams, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        let selectedPalette = convertStylesToPalette(data)
        dispatch(setSelectedPalette(selectedPalette))
        dispatch(loaded(''))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })

    let palettes = [
      ['#ffffff', '#28bec1', '#f1f2f6', '#ffffff', '#414141'],
      ['#168ccc', '#1fa1de', '#f1f2f6', '#272a33', '#414141'],
      ['#69D2E7', '#A7DBD8', '#E0E4CC', '#F38630', '#FA6900'],
      ['#FE4365', '#FC9D9A', '#F9CDAD', '#C8C8A9', '#83AF9B'],
      ['#ECD078', '#D95B43', '#C02942', '#542437', '#53777A'],
      ['#556270', '#4ECDC4', '#C7F464', '#FF6B6B', '#C44D58'],
      ['#774F38', '#E08E79', '#F1D4AF', '#ECE5CE', '#C5E0DC'],
      ['#414141', '#414141', '#F1F2F6', '#272A33', '#414141']]

    dispatch(setPalettes(palettes))
  }

  function clearColorsWS() {
    dispatch(setColors([]))
  }
  function saveColorsMappingWS(body) {
    dispatch(loading(''))
    let entryPoint = Constants.UrlsConstants.styleEntryPoint
    let method = Constants.MethodsWSConstants.STYLES.COLORS_MAPPING
    let queryParams = appId
    
    let formData = new FormData();
    let fileToSave = new Blob([JSON.stringify(body)], {
      type: 'application/json',
      name: 'colorMapping.json'
    })
    formData.append('file', fileToSave)
    let headers = {
      'authtoken': Constants.UrlsConstants.header.authtoken,
      'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
    }
    return fetch(urlServer + entryPoint + method + queryParams, {
      method: 'PUT',
      body: formData,
      headers
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(() => {
        fetchColorsMappingWS()
        dispatch(loaded('Error.Croutons.saveSuccess'))
        // fetchAppsAction(dispatch, data).setAppDesignColorsInStore()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }
  function fetchColorsMappingWS() {
    let entryPoint = Constants.UrlsConstants.styleEntryPoint
    let method = Constants.MethodsWSConstants.STYLES.COLORS_MAPPING
    let queryParams = appId

    return fetch(urlServer + entryPoint + method + queryParams, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setMapping(data))
        // fetchAppsAction(dispatch, data).setAppDesignColorsInStore()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }
  function fetchColorsWS() {
    // build url
    let entryPoint = Constants.UrlsConstants.styleEntryPoint
    let method = Constants.MethodsWSConstants.STYLES.FETCH_COLORS
    let queryParams = appId

    return fetch(urlServer + entryPoint + method + queryParams, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setColors(data))
        dispatch(loaded(''))
        fetchAppsAction(dispatch, data).setAppDesignColorsInStore()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }
  function saveColorsWS(body) {
    // build url
    let entryPoint = Constants.UrlsConstants.styleEntryPoint
    let method = Constants.MethodsWSConstants.APPS.UPDATE_STYLES + appId
    dispatch(loading(''))

    fetch(urlServer + entryPoint + method, {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchColorsWS()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  return {
    fetch: fetchWS,
    clearColorsWS,
    fetchColorsWS,
    saveColorsWS,
    saveColorsMappingWS,
    fetchColorsMappingWS
  }
}

export function saveActions(dispatch, app) {
  function saveDesign() {
    // build url
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.UPDATE_APP
    let queryParams = Constants.AppsConstants.DESIGN.APPLICATION_DESIGN

    let body = {
      id: app.id, name: app.name,
      logo: app.logo,
      splashscreen: app.splashscreen,
      iconNotif: app.iconNotif,
      copyright: app.copyright,
      spaceDef: app.spaceDef,
      theme: app.theme,
    }

    dispatch(loading(''))

    return fetch(urlServer + entryPoint + method + queryParams, {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        fetchAppsAction(dispatch, data).setAppDesignInStore()
        dispatch(loaded('Error.Croutons.saveSuccess'))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  return {
    saveDesign,
  }
}

export function fontActions(dispatch, appId, font) {
  function fetchFontsWS() {
    // build url
    let entryPoint = Constants.UrlsConstants.styleEntryPoint
    let method = Constants.MethodsWSConstants.STYLES.FETCH_FONTS
    let queryParams = appId

    return fetch(urlServer + entryPoint + method + queryParams, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setFonts(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function addFonts() {
    let entryPoint = Constants.UrlsConstants.styleEntryPoint
    let method = Constants.MethodsWSConstants.STYLES.ADD_FONTS + appId
    let formData = new FormData()
    for (let key in font) {
      formData.append(key, font[key])
    }

    let headers = {
      'authtoken': Constants.UrlsConstants.header.authtoken,
      'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
    }
    fetch(urlServer + entryPoint + method, {
      method: 'POST',
      body: formData,
      headers,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(() => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchFontsWS()
      })
  }

  function deleteFonts() {
    // build url
    let entryPoint = Constants.UrlsConstants.styleEntryPoint
    let method = Constants.MethodsWSConstants.STYLES.ADD_FONTS
    let queryParams = appId + '/' + font.id

    return fetch(urlServer + entryPoint + method + queryParams, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(() => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        this.fetchFontsWS()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  return {
    fetchFontsWS,
    addFonts,
    deleteFonts,
  }
}

function convertStylesToPalette(styles) {
  let palette = []
  let cleanStyles = {}
  styles.forEach(function (item, index) {
    if (item.category === Constants.AppsConstants.STYLES.CATEGORIES.PALETTE) {
      if (!item.color) {
        cleanStyles[item.elementId] = ''
      } else {
        cleanStyles[item.elementId] = (item.color.length === 9 ? item.color.slice(0, 7) : item.color)
      }
    }
  })

  palette.push(cleanStyles[Constants.AppsConstants.STYLES.ELEMENTS.COLOR_ID_1])
  palette.push(cleanStyles[Constants.AppsConstants.STYLES.ELEMENTS.COLOR_ID_2])
  palette.push(cleanStyles[Constants.AppsConstants.STYLES.ELEMENTS.COLOR_ID_3])
  palette.push(cleanStyles[Constants.AppsConstants.STYLES.ELEMENTS.COLOR_USER_COLOR_1])
  palette.push(cleanStyles[Constants.AppsConstants.STYLES.ELEMENTS.COLOR_USER_COLOR_2])
  palette.push(cleanStyles[Constants.AppsConstants.STYLES.ELEMENTS.COLOR_USER_COLOR_3])

  return palette
}

// function convertPaletteToStyles(palette) {
//   let styles = []
//   styles.push({ elementId: Constants.AppsConstants.STYLES.ELEMENTS.COLOR_ID_1, color: palette[0] })
//   styles.push({ elementId: Constants.AppsConstants.STYLES.ELEMENTS.COLOR_ID_2, color: palette[1] })
//   styles.push({ elementId: Constants.AppsConstants.STYLES.ELEMENTS.COLOR_ID_3, color: palette[2] })
//   styles.push({ elementId: Constants.AppsConstants.STYLES.ELEMENTS.COLOR_USER_COLOR_1, color: palette[3] })
//   styles.push({ elementId: Constants.AppsConstants.STYLES.ELEMENTS.COLOR_USER_COLOR_2, color: palette[4] })
//   styles.push({ elementId: Constants.AppsConstants.STYLES.ELEMENTS.COLOR_USER_COLOR_3, color: palette[5] })

//   return styles
// }

export function uploadColors(dispatch, file, appID) {
  function upload() {
    if (appID && file) {
      let entryPoint = 'style/uploadColorsFromCsv/'
      let formData = new FormData()
      formData.append('file', file)

      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }
      dispatch(uploading())

      return fetch(urlServer + entryPoint + appID, {
        method: 'POST',
        body: formData,
        headers,
      })
        // .then(res => progress(res.body, res))
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(() => {
          dispatch(loaded('Error.Croutons.uploadSuccess'))
          // dispatch(uploadSuccess())
          dispatch(endUploading())
          palettesAction(dispatch, appID, null).fetchColorsWS(true)
        })
        .catch((error) => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.uploadFail'))
          }
        })
    }
  }

  return {
    upload,
  }
}
